// import { createGlobalState } from 'react-hooks-global-state'

// const initialState = { photoToScrollTo: null }
// const { useGlobalState } = createGlobalState(initialState)

// export const useLastViewedPhoto = () => {
//   return useGlobalState('photoToScrollTo')
// }


import { createGlobalState } from 'react-hooks-global-state'

const initialState = { photoToScrollTo: null as string | null}
const { useGlobalState } = createGlobalState(initialState)
type LastViewedPhotoHook = readonly [string | null, (photoId: string | null) => void];

export const useLastViewedPhoto = () : LastViewedPhotoHook => {
  return useGlobalState('photoToScrollTo')
}
